import { DEVICE_WIDTHS } from '@amzn/carrierlogistics-commons/dist/constants/breakpoints';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Responsive from '@amzn/meridian/responsive';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { css } from '@emotion/css';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import OneStopImage from '../../images/one_stop.svg';
import PerformanceVisImage from '../../images/performance_vis.svg';
import ReducedCostImage from '../../images/reduced_cost.svg';

const WhyAmazonContentBlock = () => (
  <Box
    alignmentHorizontal="center"
    backgroundColor="#f0f1f2"
    spacingInset="500"
  >
    <Text
      alignment="center"
      type="h600"
      fontFamily="amazonEmber"
      className={css`
        letter-spacing: -1px;
        font-weight: 500 !important;
        margin-bottom: 32px !important;
      `}
    >
      <FormattedMessage id="home_page.why_amazon.title" />
    </Text>
    <Responsive
      query="max-width"
      props={{
        wrap: {
          default: 'none',
          [DEVICE_WIDTHS.TABLET]: 'down',
        },
        alignmentHorizontal: {
          default: 'justify',
          [DEVICE_WIDTHS.TABLET]: 'center',
        },
      }}
    >
      {({ wrap, alignmentHorizontal }) => (
        <Row
          width="100%"
          alignmentHorizontal={alignmentHorizontal}
          alignmentVertical="top"
          spacing="600"
          wrap={wrap}
        >
          <Column alignmentHorizontal="center">
            <img src={OneStopImage} height="96px" alt="Logo" />
            <Text alignment="center" type="h300" fontFamily="amazonEmber">
              <FormattedMessage id="home_page.why_amazon.benefits.one_stop.title" />
            </Text>
            <Text alignment="center" type="b100" fontFamily="amazonEmber">
              <FormattedMessage id="home_page.why_amazon.benefits.one_stop.description" />
            </Text>
          </Column>
          <Column alignmentHorizontal="center">
            <img src={ReducedCostImage} height="96px" alt="Logo" />
            <Text
              alignment="center"
              type="h300"
              fontFamily="amazonEmber"
              className={css`
                margin-bottom: 40px !important;
              `}
            >
              <FormattedMessage id="home_page.why_amazon.benefits.reduced_costs.title" />
            </Text>
            <Text alignment="center" type="b100" fontFamily="amazonEmber">
              <FormattedMessage id="home_page.why_amazon.benefits.reduced_costs.description" />
            </Text>
          </Column>
          <Column alignmentHorizontal="center">
            <img src={PerformanceVisImage} height="96px" alt="Logo" />
            <Text
              alignment="center"
              type="h300"
              fontFamily="amazonEmber"
              className={css`
                margin-bottom: 40px !important;
              `}
            >
              <FormattedMessage id="home_page.why_amazon.benefits.performance_vis.title" />
            </Text>
            <Text alignment="center" type="b100" fontFamily="amazonEmber">
              <FormattedMessage id="home_page.why_amazon.benefits.performance_vis.description" />
            </Text>
          </Column>
        </Row>
      )}
    </Responsive>
  </Box>
);

export default WhyAmazonContentBlock;
